/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";
import { NavLink, useLocation } from "react-router-dom";

import { usePermissionRoleUIContext } from "../../../../../app/Components/PermissionRole";
import { EmailVerifiedAlert } from "../../../../../app/Components/PopupLogin/emailVerifiedAlert";
import {
  ROLE_ASSET_MANAGER,
  ROLE_SUPER_ADMIN
} from "../../../../../app/Utils/constant";
import {
  toAbsoluteUrl,
  checkIsActive,
  checkIsAllow
} from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();

  const {
    setPermissionRoles,
    rolePermissionData
  } = usePermissionRoleUIContext();

  const [rolesPermissionData, setRolesPermissionData] = useState(null);

  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (rolePermissionData) {
      const tempData = rolePermissionData.getAllPermissionsByRoleKeys;

      window.localStorage.setItem("permissions", JSON.stringify(tempData));

      setRolesPermissionData(tempData);
    }
  }, [rolePermissionData]);
  useEffect(() => {
    setPermissionRoles();
  }, [setPermissionRoles]);
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const getSellerInfo = () => {
    const roles = JSON.parse(window.localStorage.getItem("roles"));

    if (!roles) {
      return false;
    }

    if (roles && roles.length <= 0) {
      return false;
    }

    if (roles && roles.length === 1 && roles[0] === "buyer") {
      return false;
    }

    if (roles && roles.findIndex(index => index === "seller") > -1) return true;
    else return false;
  };

  const checkISAMORSA = () => {
    const roles = JSON.parse(window.localStorage.getItem("roles"));

    if (!roles) {
      return false;
    }

    if (
      roles &&
      roles.length === 1 &&
      (roles[0] === ROLE_ASSET_MANAGER || roles[0] === ROLE_SUPER_ADMIN)
    ) {
      return true;
    } else return false;
  };

  const getVerifiedStatus = () => {
    const user = JSON.parse(window.localStorage.getItem("user"));

    if (user) {
      return user.isUserVerified;
    } else return false;
  };

  const handleClick = e => {
    const user = JSON.parse(window.localStorage.getItem("user"));

    if (!user.isEmailVarified) {
      e.preventDefault();
      setShowAlert(true);
    } else setShowAlert(false);
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        {checkIsAllow("dashboard", null, rolesPermissionData) && (
          <li
            className={`menu-item ${getMenuItemActive(
              "/admin/dashboard",
              false
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/admin/dashboard">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                />
              </span>
              <span className="menu-text">
                <FormattedMessage id="DASHBOARD.TITLE" />
              </span>
            </NavLink>
          </li>
        )}
        {/*end::1 Level*/}

        {/* Organizations */}
        {/*begin::1 Level*/}
        {checkIsAllow("organizations", null, rolesPermissionData) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/admin/react-bootstrap",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink
              className="menu-link menu-toggle"
              to="/admin/react-bootstrap"
            >
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}
                />
              </span>
              <span className="menu-text">
                <FormattedMessage id="ORGANIZATION.TITLE" />
              </span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Organizations</span>
                    </span>
                  </li>

                  {/*begin::2 Level*/}
                  {checkIsAllow(
                    "organizationList",
                    "organizations",
                    rolesPermissionData
                  ) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/alert"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to={{
                          pathname: "/admin/organizations-list",
                          state: "organizations"
                        }}
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          <FormattedMessage id="ORGANIZATION.LIST" />
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  {checkIsAllow(
                    "usersList",
                    "organizations",
                    rolesPermissionData
                  ) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/badge"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to={{
                          pathname: "/admin/buyer-seller-list",
                          state: "organizations"
                        }}
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          <FormattedMessage id="USERS.TITLE" />
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}
                </ul>
              </ul>
            </div>
          </li>
        )}
        {/*end::1 Level*/}

        {/* Assets */}
        {/*begin::1 Level*/}
        {checkIsAllow("assets", null, rolesPermissionData) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/react-bootstrap",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/react-bootstrap">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Library.svg")} />
              </span>
              <span className="menu-text">
                <FormattedMessage id="ASSET.TITLE" />
              </span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Assets</span>
                    </span>
                  </li>

                  {/*begin::2 Level*/}
                  {checkIsAllow("allAssets", "assets", rolesPermissionData) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/alert"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to={{
                          pathname: "/admin/all-assets",
                          state: "assets"
                        }}
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          <FormattedMessage id="ALLASSETS.TITLE" />
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  {checkIsAllow(
                    "assetsUnderNegotiation",
                    "assets",
                    rolesPermissionData
                  ) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/badge"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to={{
                          pathname: "/admin/assets-under-negotiation",
                          state: "assets"
                        }}
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          <FormattedMessage id="ASSETS_UNDER_NEGOTIATION.TITLE" />
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}
                  {/*begin::3 Level*/}
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/badge"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to={{
                        pathname: "/admin/inspection-list",
                        state: "assets"
                      }}
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        <FormattedMessage id="INSPECTION.TITLE" />
                      </span>
                    </NavLink>
                  </li>
                  {/*end::3 Level*/}
                  {/*begin::3 Level*/}
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/badge"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/admin/want-to-buy-assets"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Want to Buy</span>
                    </NavLink>
                  </li>
                  {/*end::3 Level*/}
                  {/*begin::3 Level*/}
                  {checkISAMORSA() && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/badge"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/admin/assets-extend-timer-request"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Extend Timer Request</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::3 Level*/}
                </ul>
              </ul>
            </div>
          </li>
        )}
        {/*end::1 Level*/}

        {/* Buying */}
        {/*begin::1 Level*/}
        {checkIsAllow("buying", null, rolesPermissionData) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/react-bootstrap",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/react-bootstrap">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")}
                />
              </span>
              <span className="menu-text">Buyer</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Buyer</span>
                    </span>
                  </li>

                  {/*begin::2 Level*/}
                  {checkIsAllow("allAssets", "buying", rolesPermissionData) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/alert"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/admin/buyer-assets">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          <FormattedMessage id="ASSETS_UNDER_NEGOTIATION.TITLE" />
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  {checkIsAllow(
                    "assetsUnderNegotiation",
                    "buying",
                    rolesPermissionData
                  ) && (
                    <></>
                  )}
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  {checkIsAllow(
                    "purchasedAssets",
                    "buying",
                    rolesPermissionData
                  ) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/badge"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to={{
                          pathname: "/admin/inquiries/buyer-list",
                          state: "buying"
                        }}
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Inquiries</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  {checkIsAllow(
                    "savedAssets",
                    "buying",
                    rolesPermissionData
                  ) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/badge"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to={{
                          pathname: "/admin/saved-assets"
                        }}
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Lists</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  {checkIsAllow("wantToBuy", "buying", rolesPermissionData) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/badge"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/admin/want-to-buy-assets"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Want to Buy</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}
                  {/*begin::2 Level*/}
                  {checkIsAllow(
                    "purchasedAssets",
                    "buying",
                    rolesPermissionData
                  ) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/badge"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/admin/purchased-assets"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Purchased</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}
                </ul>
              </ul>
            </div>
          </li>
        )}
        {/*end::1 Level*/}

        {/* Selling */}
        {/*begin::1 Level*/}
        {checkIsAllow("selling", null, rolesPermissionData) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/react-bootstrap",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/react-bootstrap">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag2.svg")}
                />
              </span>
              <span className="menu-text">Seller</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Seller</span>
                    </span>
                  </li>

                  {/*begin::2 Level*/}
                  {checkIsAllow(
                    "allAssets",
                    "selling",
                    rolesPermissionData
                  ) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/alert"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to={{
                          pathname: "/admin/all-assets",
                          state: "selling"
                        }}
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">All Assets</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  {/* {checkIsAllow(
                    'assetsUnderNegotiation',
                    'selling',
                    rolesPermissionData
                  ) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        '/react-bootstrap/badge'
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to={{
                          pathname: '/admin/selling-assets-under-negotiation',
                          state: 'selling',
                        }}
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">  </span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*end::2 Level*/}
                  {/*begin::2 Level*/}
                  {checkIsAllow(
                    "assetsUnderNegotiation",
                    "selling",
                    rolesPermissionData
                  ) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/badge"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to={{
                          pathname: "/admin/seller-offer",
                          state: "selling"
                        }}
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Offers</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}
                  {/*begin::2 Level*/}

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/badge"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to={{
                        pathname: "/admin/inquiries/seller-list",
                        state: "selling"
                      }}
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Inquiries</span>
                    </NavLink>
                  </li>

                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  {checkIsAllow(
                    "soldAssets",
                    "selling",
                    rolesPermissionData
                  ) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/badge"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/admin/sold-assets">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Sold</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::3 Level*/}
                  {/*begin::3 Level*/}

                  {/* <li
                    className={`menu-item ${getMenuItemActive(
                      "/react-bootstrap/badge"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/sellerinfo">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Become a Seller</span>
                    </NavLink>
                  </li> */}
                  {/*end::3 Level*/}
                </ul>
              </ul>
            </div>
          </li>
        )}
        {/*end::1 Level*/}

        {/* Master Data */}
        {/*begin::1 Level*/}
        {checkIsAllow("becomeSeller", null, rolesPermissionData) &&
          !getSellerInfo() && (
            <li
              className={`menu-item ${getMenuItemActive("/sellerinfo", false)}`}
              aria-haspopup="true"
            >
              <NavLink
                className="menu-link"
                to="/admin/sellerinfo"
                onClick={handleClick}
              >
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Add-user.svg"
                    )}
                  />
                </span>
                <span className="menu-text">Become a Seller</span>
              </NavLink>
            </li>
          )}
        {/*end::1 Level*/}

        {/* Master Data */}
        {/*begin::1 Level*/}
        {checkIsAllow("masterData", null, rolesPermissionData) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/react-bootstrap",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/react-bootstrap">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Cap-2.svg")} />
              </span>
              <span className="menu-text">
                <FormattedMessage id="MASTERDATA.TITLE" />
              </span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Master Data</span>
                    </span>
                  </li>
                  {/*Global Data*/}
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/react-bootstrap",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/react-bootstrap"
                    >
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Design/Cap-2.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">
                        <FormattedMessage id="GLOBAL.DATA" />
                      </span>
                      <i className="menu-arrow" />
                    </NavLink>
                    <div className="menu-submenu ">
                      <ul className="menu-subnav">
                        <ul className="menu-subnav">
                          <li
                            className="menu-item  menu-item-parent"
                            aria-haspopup="true"
                          >
                            <span className="menu-link">
                              <span className="menu-text">Global Data</span>
                            </span>
                          </li>
                          {/*begin::2 Level*/}
                          {checkIsAllow(
                            "currencies",
                            "masterData",
                            rolesPermissionData
                          ) && (
                            <li
                              className={`menu-item ${getMenuItemActive(
                                "/react-bootstrap/alert"
                              )}`}
                              aria-haspopup="true"
                            >
                              <NavLink
                                className="menu-link"
                                to="/admin/currencies"
                              >
                                <i className="menu-bullet menu-bullet-dot">
                                  <span />
                                </i>
                                <span className="menu-text">
                                  <FormattedMessage id="CURRENCIES.TITLE" />
                                </span>
                              </NavLink>
                            </li>
                          )}
                          {/*end::2 Level*/}

                          {/*begin::2 Level*/}
                          {checkIsAllow(
                            "worldData",
                            "masterData",
                            rolesPermissionData
                          ) && (
                            <li
                              className={`menu-item ${getMenuItemActive(
                                "/react-bootstrap/badge"
                              )}`}
                              aria-haspopup="true"
                            >
                              <NavLink
                                className="menu-link"
                                to="/admin/world-data"
                              >
                                <i className="menu-bullet menu-bullet-dot">
                                  <span />
                                </i>
                                <span className="menu-text">
                                  <FormattedMessage id="WORLD_DATA.TITLE" />
                                </span>
                              </NavLink>
                            </li>
                          )}
                          {/*end::2 Level*/}
                        </ul>
                      </ul>
                    </div>
                  </li>
                  {/*Global Data*/}
                  {/*Seller Data*/}
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/react-bootstrap",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/react-bootstrap"
                    >
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Design/Cap-2.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">
                        <FormattedMessage id="SELLER.TITLE" />
                      </span>
                      <i className="menu-arrow" />
                    </NavLink>
                    <div className="menu-submenu ">
                      <ul className="menu-subnav">
                        <ul className="menu-subnav">
                          <li
                            className="menu-item  menu-item-parent"
                            aria-haspopup="true"
                          >
                            <span className="menu-link">
                              <span className="menu-text">Seller Data</span>
                            </span>
                          </li>
                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/react-bootstrap/badge"
                            )}`}
                            aria-haspopup="true"
                          >
                            <NavLink
                              className="menu-link"
                              to="/admin/business-type"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">
                                <FormattedMessage id="BUSINESS.TYPE" />
                              </span>
                            </NavLink>
                          </li>

                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/react-bootstrap/badge"
                            )}`}
                            aria-haspopup="true"
                          >
                            <NavLink
                              className="menu-link"
                              to="/admin/company-type"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">
                                <FormattedMessage id="COMPANY.TYPE" />
                              </span>
                            </NavLink>
                          </li>

                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/react-bootstrap/badge"
                            )}`}
                            aria-haspopup="true"
                          >
                            <NavLink
                              className="menu-link"
                              to="/admin/subscription"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">
                                <FormattedMessage id="SUBSCRIPTION.TITLE" />
                              </span>
                            </NavLink>
                          </li>
                        </ul>
                      </ul>
                    </div>
                  </li>
                  {/*Seller Data*/}

                  {/*Asset Data*/}
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/react-bootstrap",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/react-bootstrap"
                    >
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Design/Cap-2.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">
                        <FormattedMessage id="ASSETS.DATA" />
                      </span>
                      <i className="menu-arrow" />
                    </NavLink>
                    <div className="menu-submenu ">
                      <ul className="menu-subnav">
                        <ul className="menu-subnav">
                          <li
                            className="menu-item  menu-item-parent"
                            aria-haspopup="true"
                          >
                            <span className="menu-link">
                              <span className="menu-text">Asset Data</span>
                            </span>
                          </li>
                          {/*begin::2 Level*/}
                          {checkIsAllow(
                            "assetsCategories",
                            "masterData",
                            rolesPermissionData
                          ) && (
                            <li
                              className={`menu-item ${getMenuItemActive(
                                "/react-bootstrap/badge"
                              )}`}
                              aria-haspopup="true"
                            >
                              <NavLink
                                className="menu-link"
                                to={{
                                  pathname: "/admin/asset-class",
                                  state: "masterData"
                                }}
                              >
                                <i className="menu-bullet menu-bullet-dot">
                                  <span />
                                </i>
                                <span className="menu-text">
                                  <FormattedMessage id="ASSETS.CLASS" />
                                </span>
                              </NavLink>
                            </li>
                          )}
                          {/*end::2 Level*/}

                          {/*begin::2 Level*/}
                          {checkIsAllow(
                            "assetsCategories",
                            "masterData",
                            rolesPermissionData
                          ) && (
                            <li
                              className={`menu-item ${getMenuItemActive(
                                "/react-bootstrap/badge"
                              )}`}
                              aria-haspopup="true"
                            >
                              <NavLink
                                className="menu-link"
                                to={{
                                  pathname: "/admin/asset-categories",
                                  state: "masterData"
                                }}
                              >
                                <i className="menu-bullet menu-bullet-dot">
                                  <span />
                                </i>
                                <span className="menu-text">
                                  <FormattedMessage id="ASSETS.CATEGORIES" />
                                </span>
                              </NavLink>
                            </li>
                          )}
                          {/*end::2 Level*/}

                          {/*begin::3 Level*/}
                          {checkIsAllow(
                            "assetsMake",
                            "masterData",
                            rolesPermissionData
                          ) && (
                            <li
                              className={`menu-item ${getMenuItemActive(
                                "/react-bootstrap/badge"
                              )}`}
                              aria-haspopup="true"
                            >
                              <NavLink
                                className="menu-link"
                                to={{
                                  pathname: "/admin/asset-make",
                                  state: "masterData"
                                }}
                              >
                                <i className="menu-bullet menu-bullet-dot">
                                  <span />
                                </i>
                                <span className="menu-text">
                                  <FormattedMessage id="ASSETS.MAKE" />
                                </span>
                              </NavLink>
                            </li>
                          )}
                          {/*end::3 Level*/}

                          {/*begin::4 Level*/}
                          {checkIsAllow(
                            "assetsModel",
                            "masterData",
                            rolesPermissionData
                          ) && (
                            <li
                              className={`menu-item ${getMenuItemActive(
                                "/react-bootstrap/badge"
                              )}`}
                              aria-haspopup="true"
                            >
                              <NavLink
                                className="menu-link"
                                to={{
                                  pathname: "/admin/asset-model",
                                  state: "masterData"
                                }}
                              >
                                <i className="menu-bullet menu-bullet-dot">
                                  <span />
                                </i>
                                <span className="menu-text">
                                  <FormattedMessage id="ASSETS.MODEL" />
                                </span>
                              </NavLink>
                            </li>
                          )}
                          {/*end::4 Level*/}
                          {/*begin::5 Level*/}
                          {/* {checkIsAllow(
                            'assetsModel',
                            'masterData',
                            rolesPermissionData
                          ) && ( */}
                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/react-bootstrap/badge"
                            )}`}
                            aria-haspopup="true"
                          >
                            <NavLink
                              className="menu-link"
                              to={{
                                pathname: "/admin/master-badges",
                                state: "masterData"
                              }}
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">
                                <FormattedMessage id="ASSETS.BADGES" />
                              </span>
                            </NavLink>
                          </li>
                          {/* )} */}
                          {/*end::5 Level*/}
                        </ul>
                      </ul>
                    </div>
                  </li>
                  {/*Asset Data*/}

                  {/*Negotiation Data*/}
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/react-bootstrap",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/react-bootstrap"
                    >
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Design/Cap-2.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">
                        <FormattedMessage id="NEGOTIATION.TITLE" />
                      </span>
                      <i className="menu-arrow" />
                    </NavLink>
                    <div className="menu-submenu ">
                      <ul className="menu-subnav">
                        <ul className="menu-subnav">
                          <li
                            className="menu-item  menu-item-parent"
                            aria-haspopup="true"
                          >
                            <span className="menu-link">
                              <span className="menu-text">
                                Negotiation Data
                              </span>
                            </span>
                          </li>
                          {/*begin::5 Level*/}
                          {checkIsAllow(
                            "globalSettings",
                            "masterData",
                            rolesPermissionData
                          ) && (
                            <li
                              className={`menu-item ${getMenuItemActive(
                                "/react-bootstrap/badge"
                              )}`}
                              aria-haspopup="true"
                            >
                              <NavLink
                                className="menu-link"
                                to="/admin/global-setting"
                              >
                                <i className="menu-bullet menu-bullet-dot">
                                  <span />
                                </i>
                                <span className="menu-text">
                                  <FormattedMessage id="GOLBAL_SETTING.TITLE" />
                                </span>
                              </NavLink>
                            </li>
                          )}
                          {/*end::5 Level*/}
                        </ul>
                      </ul>
                    </div>
                  </li>
                  {/*Negotiation Data*/}
                  {/*Logistics Data*/}
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/react-bootstrap",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/react-bootstrap"
                    >
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Design/Cap-2.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">
                        <FormattedMessage id="LOGISTIC.TITLE" />
                      </span>
                      <i className="menu-arrow" />
                    </NavLink>
                    <div className="menu-submenu ">
                      <ul className="menu-subnav">
                        <ul className="menu-subnav">
                          <li
                            className="menu-item  menu-item-parent"
                            aria-haspopup="true"
                          >
                            <span className="menu-link">
                              <span className="menu-text">Logistics Data</span>
                            </span>
                          </li>

                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/react-bootstrap/badge"
                            )}`}
                            aria-haspopup="true"
                          >
                            <NavLink
                              className="menu-link"
                              to="/admin/logistic-partner"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">
                                <FormattedMessage id="LOGISTIC.PARTNER" />
                              </span>
                            </NavLink>
                          </li>

                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/react-bootstrap/badge"
                            )}`}
                            aria-haspopup="true"
                          >
                            <NavLink
                              className="menu-link"
                              to="/admin/logistic-type"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">
                                <FormattedMessage id="LOGISTIC_SERVICE_OFFERED" />
                              </span>
                            </NavLink>
                          </li>
                        </ul>
                      </ul>
                    </div>
                  </li>
                  {/*Logistics Data*/}
                  {/*Finance Date*/}
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/react-bootstrap",
                      true
                    )}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                  >
                    <NavLink
                      className="menu-link menu-toggle"
                      to="/react-bootstrap"
                    >
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Design/Cap-2.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">
                        <FormattedMessage id="FINANCE.TITLE" />
                      </span>
                      <i className="menu-arrow" />
                    </NavLink>
                    <div className="menu-submenu ">
                      <ul className="menu-subnav">
                        <ul className="menu-subnav">
                          <li
                            className="menu-item  menu-item-parent"
                            aria-haspopup="true"
                          >
                            <span className="menu-link">
                              <span className="menu-text">Finance Data</span>
                            </span>
                          </li>

                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/react-bootstrap/badge"
                            )}`}
                            aria-haspopup="true"
                          >
                            <NavLink
                              className="menu-link"
                              to="/admin/finance-partner"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">
                                <FormattedMessage id="FINANCE.PARTNER" />
                              </span>
                            </NavLink>
                          </li>

                          <li
                            className={`menu-item ${getMenuItemActive(
                              "/react-bootstrap/badge"
                            )}`}
                            aria-haspopup="true"
                          >
                            <NavLink
                              className="menu-link"
                              to="/admin/service-offered"
                            >
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">
                                <FormattedMessage id="SERVICE_OFFERED" />
                              </span>
                            </NavLink>
                          </li>
                        </ul>
                      </ul>
                    </div>
                  </li>
                  {/*Finance Date*/}
                </ul>
              </ul>
            </div>
          </li>
        )}
        {/*end::1 Level*/}

        {/* Organization Settings */}
        {/*begin::1 Level*/}
        {/* {checkIsAllow('Organization Setting') && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              '/react-bootstrap',
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/react-bootstrap">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Home/Library.svg')} />
              </span>
              <span className="menu-text">Organization Settings</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Organization Settings</span>
                    </span>
                  </li>

                  {/*begin::2 Level*/}
        {/* <li
                    className={`menu-item ${getMenuItemActive(
                      '/react-bootstrap/alert'
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/admin/company-subscriptions"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Manage Subscriptions</span>
                    </NavLink>
                  </li>
                  {/*end::2 Level*/}

        {/*begin::2 Level*/}
        {/* <li
                    className={`menu-item ${getMenuItemActive(
                      '/react-bootstrap/badge'
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/admin/company-Locations"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Manage Locations</span>
                    </NavLink>
                  </li>
                  {/*end::2 Level*/}
        {/* </ul>
              </ul>
            </div>
          </li>
        )}   */}
        {/*end::1 Level*/}

        {/* Services */}
        {/*begin::1 Level*/}
        {checkIsAllow("services", null, rolesPermissionData) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/react-bootstrap",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/react-bootstrap">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Code/Error-circle.svg")}
                />
              </span>
              <span className="menu-text">
                <FormattedMessage id="SERVICES.TITLE" />
              </span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Services</span>
                    </span>
                  </li>

                  {/*begin::2 Level*/}
                  {checkIsAllow(
                    "financeCompanies",
                    "services",
                    rolesPermissionData
                  ) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/alert"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to={{
                          pathname: "/admin/finance-companies",
                          state: "services"
                        }}
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          <FormattedMessage id="FIN_COMPANY.TITLE" />
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  {checkIsAllow(
                    "transportationCompanies",
                    "services",
                    rolesPermissionData
                  ) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/react-bootstrap/badge"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to={{
                          pathname: "/admin/transport-companies",
                          state: "services"
                        }}
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          <FormattedMessage id="TRANS_COMPANY.TITLE" />
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}
                </ul>
              </ul>
            </div>
          </li>
        )}
        {/*end::1 Level*/}

        {/* Support */}
        {/*begin::1 Level*/}
        {checkIsAllow("support", null, rolesPermissionData) && (
          <li
            className={`menu-item ${getMenuItemActive("/support", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/admin/support">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Add-user.svg"
                  )}
                />
              </span>
              <span className="menu-text">
                <FormattedMessage id="SUPPORT.TITLE" />
              </span>
            </NavLink>
          </li>
        )}
        {/*end::1 Level*/}

        {/* Roles & Permissions */}
        {/*begin::1 Level*/}

        {/*end::1 Level*/}
        {/* Roles & Permissions */}
        {/*begin::1 Level*/}
        {(checkIsAllow("myAccount", null, rolesPermissionData) ||
          !getVerifiedStatus()) && (
          <li
            className={`menu-item ${getMenuItemActive("/user-profile", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/admin/user-profile">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Add-user.svg"
                  )}
                />
              </span>
              <span className="menu-text">
                <FormattedMessage id="MY_ACCOUNT.TITLE" />
              </span>
            </NavLink>
          </li>
        )}
        {/*end::1 Level*/}
      </ul>

      {/* end::Menu Nav */}
      {showAlert && <EmailVerifiedAlert setShowAlert={setShowAlert} />}
    </>
  );
}
